import * as React from 'react';
import {ReactElement} from 'react';
import classnames from 'classnames';

import {IContentBlock} from 'features/blocks/types';
import {EpiLink} from 'features/template/types';
import {HeadlineLevel, Margin, ParagraphSize} from 'features/ui/enums';
import {useDeviceStore, selectIsMobile, selectIsTablet} from 'features/ui/store/useDeviceStore';

import 'components/blocks/Headers/LeftAlignHeaderBlock/style.scss';

import {P} from '@atoms/Text/P';
import {Icon} from '@atoms/Media/Icon';
import {UserAgent} from '@atoms/UserAgent';
import {Headline} from '@atoms/Text/Headline';
import {Container} from '@atoms/Layout/Container';
import {ButtonLink} from '@atoms/LinksAndButtons/ButtonLink';
import { ButtonColor, ButtonSize, ButtonType } from '@atoms/LinksAndButtons/Button';

export interface LeftAlignHeaderBlockType {
    title: string;
    preamble: string;
    buttons: EpiLink[];
    icon: string;
    customIconContent?: ReactElement;
    centerIcon?: boolean;
}

interface Props extends IContentBlock<LeftAlignHeaderBlockType>{

    children?: React.ReactNode;
}

export const LeftAlignHeaderBlock: React.FunctionComponent<Props> = (props) => {
    const isMobile = useDeviceStore(selectIsMobile);
    const isTablet = useDeviceStore(selectIsTablet);

    const renderButtons = () => {
        if(props.data.buttons === null) return null;

        return (
            <div className="left-align-header-block__buttons">
                {props.data.buttons.map((link, index) => (
                    <ButtonLink 
                        href={link.url} 
                        key={`button-${index}`} 
                        buttonColor={ButtonColor.DEFAULT} 
                        buttonSize={ButtonSize.DEFAULT} 
                        buttonType={isMobile 
                            ? ButtonType.HEADERBLOCK
                            : ButtonType.GHOST} 
                    >
                        {link.name}
                    </ButtonLink>
                ))}
            </div>
        );
    };

    const iconClasses = classnames('left-align-header-block__icon', {
        'left-align-header-block__icon--center': props.data.centerIcon,
        'left-align-header-block__icon--easter': process.env.NODE_ENV === 'development' && (((new Date().getMonth() > 1 && new Date().getMonth() < 4)) && new Date().getMinutes() % 3 === 0),
    });

    return (
            <div className="left-align-header-block" id={props.id}>
                <Container>
                    <div className="left-align-header-block__mobile-background">
                        <div className="left-align-header-block__text">
                            <Headline 
                                level={HeadlineLevel.H1}
                                margin={isMobile 
                                    ? !isTablet 
                                        ? Margin.S 
                                        : undefined
                                    : Margin.L
                                }
                                center={isMobile && !isTablet}
                            >
                                {props.data.title}
                            </Headline>

                            {props.data.icon &&
                                <UserAgent mobile>
                                        <div className={iconClasses}>
                                            {process.env.NODE_ENV === 'development' &&
                                                <div className="easter"></div>//Easter egg
                                            }
                                            <Icon name={props.data.icon.toLowerCase()} sizeHeaderSmall />
                                            {props.data.customIconContent &&
                                                <span className='left-align-header-block__icon__content'>{props.data.customIconContent}</span>
                                            }
                                        </div>
                                </UserAgent>
                            }
                            <P 
                                size={ParagraphSize.L} 
                                center={isMobile && !isTablet} 
                            >
                                {props.data.preamble}
                                {/* {props.data.customIconContent &&
                                    <UserAgent mobile>
                                        <span className='left-align-header-block__icon__content'>{props.data.customIconContent}</span>
                                    </UserAgent>
                                } */}
                            </P>

                            <UserAgent computer>{renderButtons()}</UserAgent>


                        </div>

                        {props.data.icon &&
                            <UserAgent tablet computer>
                                <div className={iconClasses}>
                                    {process.env.NODE_ENV === 'development' &&
                                        <div className="easter"></div>//Easter egg
                                    }
                                    <Icon
                                        name={props.data.icon.toLowerCase()}
                                        sizeHeaderLarge={!isMobile}
                                        sizeHeaderSmall={isMobile}
                                    />
                                    {props.data.customIconContent && props.data.customIconContent}
                                </div>
                            </UserAgent>
                        }

                        {props.children}
                    </div>

                    <UserAgent mobile tablet>{renderButtons()}</UserAgent>

                </Container>
            </div>
    );
};
